import React from 'react'
import CuriorStorePage from '../store'
import { useParams } from 'react-router-dom'

const EditCuriorsPage = () => {
  const {id}=useParams()  
    const mode= "edit"
     
  return (
    <div>
       <CuriorStorePage mode={mode} id={id }/>   
    </div>
  )
}

export default EditCuriorsPage